module.exports = __WEBPACK_EXTERNAL_MODULE_232__;


//////////////////
// WEBPACK FOOTER
// external "mobxReact"
// module id = 232
// module chunks = 0 1